
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/heatmap-premium",
      function () {
        return require("private-next-pages/x/api/charts/heatmap-premium.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/heatmap-premium"])
      });
    }
  